import React from 'react'
const CustomInput = ({ ...props }) => {
    
    return (
        <>
            <span className="input_wrapp">
                <input
                    type={props.type}
                    placeholder={props.placeholder}
                    value={props.value}
                    onChange={props.onChange}
                    name={props.name}
                />
            </span>
        </>
    )
}


export default CustomInput 